import {
  IconButton,
  IconButtonProps,
  Tooltip,
  useColorMode,
  useColorModeValue
} from "@chakra-ui/react";
import { FaMoon, FaSun } from "react-icons/fa";

type ColorModeSwitcherProps = Omit<IconButtonProps, "aria-label"> & {
  tooltipVariantion?: string;
};

export const ColorModeSwitcher = ({
  tooltipVariantion,
  ...props
}: ColorModeSwitcherProps) => {
  const { toggleColorMode } = useColorMode();
  const text = useColorModeValue("escuro", "claro");
  const SwitchIcon = useColorModeValue(FaMoon, FaSun);

  const iconsColor = useColorModeValue("gray.500", "gray.300");

  return (
    <Tooltip label="Trocar tema" variant={tooltipVariantion}>
      <IconButton
        size="sm"
        fontSize="md"
        variant="ghost"
        color={iconsColor}
        onClick={toggleColorMode}
        icon={<SwitchIcon />}
        aria-label={`Mudar para tema ${text}`}
        {...props}
      />
    </Tooltip>
  );
};
